module.exports = {
	"v": "4.10.2",
	"fr": 29.9700012207031,
	"ip": 0,
	"op": 236.000009612477,
	"w": 950,
	"h": 600,
	"nm": "final edit",
	"ddd": 0,
	"assets": [
		{
			"id": "comp_28",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 0,
					"nm": "monolith",
					"refId": "comp_29",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								229,
								329,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 236.000009612477,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_29",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 0,
					"nm": "pyramids",
					"refId": "comp_30",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 171,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"t": 192.00000782032
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								942.5,
								540.5,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 210.000008553475,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 0,
					"nm": "connections",
					"refId": "comp_31",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								942.5,
								540.5,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 210.000008553475,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 0,
					"nm": "monolith",
					"refId": "comp_32",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								942.5,
								540.5,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 236.000009612477,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "lines/illustrations_app_mod Outlines 3",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1326,
								562,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								423.5,
								239.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-579.279,
													-378.309
												],
												[
													-304.42,
													-220.477
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568627451,
											0.329411764706,
											0.141176470588,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 200,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 218.000008879322
											}
										],
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											490.201,
											220.85
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											62.238,
											62.126
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													91.208,
													-125.35
												],
												[
													366.066,
													32.481
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568627451,
											0.329411764706,
											0.141176470588,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 193,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 202.000008227629
											}
										],
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											-199.097,
											284.474
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											52.922,
											53.84
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-124.202,
													-370.522
												],
												[
													150.656,
													-212.691
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 193,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 206.000008390552
											}
										],
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											204.38,
											516.951
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											54.071,
											53.269
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-581.477,
													-630.554
												],
												[
													-306.617,
													-472.723
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568627451,
											0.329411764706,
											0.141176470588,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 206,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 219.000008920053
											}
										],
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											285.188,
											433.244
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											52.922,
											53.84
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													36.417,
													146.722
												],
												[
													209.233,
													246.079
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											458.727,
											107.005
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											52.922,
											53.84
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 193,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 236.000009612477
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 6,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 193.000007861051,
					"op": 236.000009612477,
					"st": 193.000007861051,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 4,
					"nm": "lines/illustrations_app_mod Outlines",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1314,
								555,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								423.5,
								239.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-582.492,
													-375.09
												],
												[
													-307.634,
													-217.258
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568627451,
											0.329411764706,
											0.141176470588,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 7,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 25.0000010182709
											}
										],
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											490.201,
											220.85
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											62.238,
											62.126
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													91.208,
													-125.35
												],
												[
													366.066,
													32.481
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568627451,
											0.329411764706,
											0.141176470588,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 0,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 9.00000036657752
											}
										],
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											-199.097,
											284.474
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											52.922,
											53.84
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-124.202,
													-370.522
												],
												[
													150.656,
													-212.691
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 0,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 13.0000005295009
											}
										],
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											204.38,
											516.951
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											52.922,
											53.84
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-581.477,
													-630.554
												],
												[
													-306.617,
													-472.723
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568627451,
											0.329411764706,
											0.141176470588,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 13,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 26.0000010590017
											}
										],
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											285.188,
											433.244
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											52.922,
											53.84
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-137.429,
													-78.916
												],
												[
													137.429,
													78.916
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											454.02,
											106.734
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											53.597,
											53.82
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 0,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 43.0000017514259
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 6,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 0,
					"op": 212.000008634937,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 6,
					"ty": 4,
					"nm": "grid/illustrations_app_mod Outlines",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 30,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1154,
								574,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								455.5,
								265,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													230.217,
													132.779
												],
												[
													-230.217,
													-132.779
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											679.884,
											133.208
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													227.252,
													131.067
												],
												[
													-227.252,
													-131.067
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											620.739,
											164.766
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													220.985,
													127.451
												],
												[
													-220.985,
													-127.451
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											558.291,
											194.411
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													221.74,
													127.887
												],
												[
													-221.74,
													-127.887
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											502.874,
											228.116
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													222.693,
													128.434
												],
												[
													-222.692,
													-128.434
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											447.646,
											261.934
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													223.748,
													129.041
												],
												[
													-223.747,
													-129.041
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											392.53,
											295.811
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													227.252,
													131.067
												],
												[
													-227.251,
													-131.067
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											339.853,
											331.098
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 7,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													227.813,
													131.39
												],
												[
													-227.813,
													-131.39
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											284.243,
											364.691
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"np": 2,
							"cix": 2,
							"ix": 8,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													226.731,
													130.766
												],
												[
													-226.73,
													-130.766
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											226.98,
											397.337
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 2,
							"cix": 2,
							"ix": 9,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-284.142,
													164.049
												],
												[
													284.142,
													-164.049
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											284.499,
											167.965
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 10",
							"np": 2,
							"cix": 2,
							"ix": 10,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-284.142,
													164.049
												],
												[
													284.142,
													-164.049
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											341.363,
											200.776
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 2,
							"cix": 2,
							"ix": 11,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-284.142,
													164.049
												],
												[
													284.142,
													-164.049
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											398.218,
											233.588
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 12",
							"np": 2,
							"cix": 2,
							"ix": 12,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-284.142,
													164.045
												],
												[
													284.142,
													-164.045
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											455.081,
											266.395
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 13",
							"np": 2,
							"cix": 2,
							"ix": 13,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-284.138,
													164.05
												],
												[
													284.138,
													-164.05
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											511.94,
											299.203
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 14",
							"np": 2,
							"cix": 2,
							"ix": 14,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-284.142,
													164.05
												],
												[
													284.142,
													-164.05
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											568.799,
											332.014
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 15",
							"np": 2,
							"cix": 2,
							"ix": 15,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-284.138,
													164.05
												],
												[
													284.138,
													-164.05
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.262745098039,
											0.262745098039,
											0.282352941176,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											625.658,
											364.826
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 16",
							"np": 2,
							"cix": 2,
							"ix": 16,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 236.000009612477,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_30",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "fifth pyramid",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1351.5,
								502.5,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								101.5,
								84.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								94.124,
								94.124,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-81.355
												],
												[
													-2.888,
													81.355
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-81.355
												],
												[
													98.565,
													23.468
												],
												[
													-2.888,
													81.355
												],
												[
													-98.565,
													23.468
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568632126,
											0.329411774874,
											0.141176477075,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											101.065,
											83.855
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 4,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													98.956,
													0
												],
												[
													-1.174,
													-57.887
												],
												[
													-98.956,
													-0.781
												],
												[
													-2.738,
													57.887
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568632126,
											0.329411774874,
											0.141176477075,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.13300000359,
											0.13300000359,
											0.156999999402,
											1
										],
										"ix": 4
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											101.456,
											108.105
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 3,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.859
											],
											"y": [
												0.003
											]
										},
										"n": [
											"0p667_1_0p859_0p003"
										],
										"t": 60,
										"s": [
											99.676
										],
										"e": [
											0
										]
									},
									{
										"t": 80.0000032584668
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 3,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 0,
					"op": 211.000008594206,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "fouth pyramid",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 27,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 39.0000015885026
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1132.5,
								461.5,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								101.5,
								84.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								63.636,
								63.636,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-81.355
												],
												[
													-2.888,
													81.355
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-81.355
												],
												[
													98.565,
													23.468
												],
												[
													-2.888,
													81.355
												],
												[
													-98.565,
													23.468
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											101.065,
											83.855
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 4,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													98.956,
													0
												],
												[
													-1.174,
													-57.887
												],
												[
													-98.956,
													-0.781
												],
												[
													-2.738,
													57.887
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.13300000359,
											0.13300000359,
											0.156999999402,
											1
										],
										"ix": 4
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											101.456,
											108.105
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 3,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.828
											],
											"y": [
												0.003
											]
										},
										"n": [
											"0p667_1_0p828_0p003"
										],
										"t": 50.005,
										"s": [
											99.676
										],
										"e": [
											0
										]
									},
									{
										"t": 70.0312528524313
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 3,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 6.00000024438501,
					"op": 217.000008838591,
					"st": 6.00000024438501,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "third pyramid",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								988.5,
								544.5,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								101.5,
								84.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								29.262,
								29.262,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-81.355
												],
												[
													-2.888,
													81.355
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-81.355
												],
												[
													98.565,
													23.468
												],
												[
													-2.888,
													81.355
												],
												[
													-98.565,
													23.468
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568632126,
											0.329411774874,
											0.141176477075,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											101.065,
											83.855
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 4,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													98.956,
													0
												],
												[
													-1.174,
													-57.887
												],
												[
													-98.956,
													-0.781
												],
												[
													-2.738,
													57.887
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568632126,
											0.329411774874,
											0.141176477075,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.13300000359,
											0.13300000359,
											0.156999999402,
											1
										],
										"ix": 4
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											101.456,
											108.105
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 3,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.75
											],
											"y": [
												0.003
											]
										},
										"n": [
											"0p667_1_0p75_0p003"
										],
										"t": 42,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 55.0000022401959
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 3,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 6.00000024438501,
					"op": 219.000008920053,
					"st": 8.00000032584668,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "second pyramid",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1184.5,
								635.5,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								101.5,
								84.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								49.495,
								49.495,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-81.355
												],
												[
													-2.888,
													81.355
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-81.355
												],
												[
													98.565,
													23.468
												],
												[
													-2.888,
													81.355
												],
												[
													-98.565,
													23.468
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											101.065,
											83.855
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 4,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													98.956,
													0
												],
												[
													-1.174,
													-57.887
												],
												[
													-98.956,
													-0.781
												],
												[
													-2.738,
													57.887
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.13300000359,
											0.13300000359,
											0.156999999402,
											1
										],
										"ix": 4
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											101.456,
											108.105
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 3,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.829
											],
											"y": [
												0.004
											]
										},
										"n": [
											"0p667_1_0p829_0p004"
										],
										"t": 30,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 50.0000020365418
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 3,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 6.00000024438501,
					"op": 217.000008838591,
					"st": 6.00000024438501,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 4,
					"nm": "first pyramid",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								963,
								650,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								101.5,
								84.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								56.559,
								56.274,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-81.355
												],
												[
													-2.888,
													81.355
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-81.355
												],
												[
													98.565,
													23.468
												],
												[
													-2.888,
													81.355
												],
												[
													-98.565,
													23.468
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											101.065,
											83.855
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 4,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													98.956,
													0
												],
												[
													-1.174,
													-57.887
												],
												[
													-98.956,
													-0.781
												],
												[
													-2.738,
													57.887
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.13300000359,
											0.13300000359,
											0.156999999402,
											1
										],
										"ix": 4
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											101.456,
											108.105
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 3,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.822
											],
											"y": [
												0.005
											]
										},
										"n": [
											"0p667_1_0p822_0p005"
										],
										"t": 5,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 25.0000010182709
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 3,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 0,
					"op": 211.000008594206,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_31",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 8",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 121,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 147,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"t": 169.000006883511
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								677,
								566,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													295.25,
													-5.75
												],
												[
													181.75,
													59
												],
												[
													241,
													96.25
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 100,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 121,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 166.000006761319
									}
								],
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 41.0000016699642,
					"op": 258.000010508555,
					"st": 41.0000016699642,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Shape Layer 7",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 121,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 149,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"t": 170.000006924242
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								952,
								540,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													171.25,
													-24.75
												],
												[
													303.75,
													52
												],
												[
													242,
													89.25
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 100,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 121,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 167.000006802049
									}
								],
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 41.0000016699642,
					"op": 258.000010508555,
					"st": 41.0000016699642,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "Shape Layer 6",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 104,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 128,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"t": 152.000006191087
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1063,
								446,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100.208,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													74,
													202.08
												],
												[
													-69,
													119.109
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568627451,
											0.329411764706,
											0.141176470588,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 100,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 104,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 151.000006150356
									}
								],
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 24.00000097754,
					"op": 241.000009816131,
					"st": 24.00000097754,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "Shape Layer 5",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 104,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 131,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"t": 156.00000635401
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1061.5,
								374.5,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								96.75,
								98.708,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													30.53,
													116.16
												],
												[
													-27.557,
													149.008
												],
												[
													-65.495,
													170.3
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.921568627451,
											0.329411764706,
											0.141176470588,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": -0.079,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 100,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 104,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 129.000005254278
									}
								],
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 24.00000097754,
					"op": 241.000009816131,
					"st": 24.00000097754,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 4,
					"nm": "Shape Layer 4",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 95,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 123,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"t": 150.000006109625
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1240,
								314,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-84.5,
													137.5
												],
												[
													-33,
													108
												],
												[
													79,
													174
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 100,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 95,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 141.000005743048
									}
								],
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 15.0000006109625,
					"op": 232.000009449554,
					"st": 15.0000006109625,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 6,
					"ty": 4,
					"nm": "Shape Layer 3",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 95,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 116,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"t": 135.000005498663
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1234,
								388,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-39,
													240.5
												],
												[
													79.5,
													171.5
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 100,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 95,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 133.000005417201
									}
								],
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 15.0000006109625,
					"op": 232.000009449554,
					"st": 15.0000006109625,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 7,
					"ty": 4,
					"nm": "Shape Layer 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 80,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 99,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"t": 129.000005254278
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								985.5,
								438,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-17.5,
													123
												],
												[
													-42.25,
													137.5
												],
												[
													47.5,
													190
												],
												[
													8.5,
													211
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 100,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 80,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 128.000005213547
									}
								],
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 0,
					"op": 217.000008838591,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 8,
					"ty": 4,
					"nm": "Shape Layer 1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 80,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 98,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"t": 115.000004684046
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								950,
								540,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													190,
													118
												],
												[
													75.75,
													184
												],
												[
													18,
													149.5
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 10,
												"ix": 1
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 100,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 80,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 114.000004643315
									}
								],
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 0,
					"op": 217.000008838591,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_32",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 0,
					"nm": "end",
					"refId": "comp_33",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.492
										],
										"y": [
											1.004
										]
									},
									"o": {
										"x": [
											1
										],
										"y": [
											0.01
										]
									},
									"n": [
										"0p492_1p004_1_0p01"
									],
									"t": 191,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 217.000008838591
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								960,
								540,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"w": 1920,
					"h": 1080,
					"ip": 191.000007779589,
					"op": 241.000009816131,
					"st": 191.000007779589,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 0,
					"nm": "start",
					"refId": "comp_34",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								960,
								540,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 77.0000031362743,
					"st": -6.00000024438501,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "black shape/illustrations_app_mod Outlines",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 9,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 44,
									"s": [
										0
									],
									"e": [
										0
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 191,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 235.000009571746
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1076,
								521,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								283.5,
								253.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								110.048,
								110.048,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-234.851,
													87.166
												],
												[
													-165.782,
													22.325
												],
												[
													-124.903,
													-5.867
												],
												[
													-102.35,
													-50.974
												],
												[
													-100.235,
													-70.003
												],
												[
													-54.423,
													-126.387
												],
												[
													-22.708,
													-110.881
												],
												[
													15.35,
													-171.494
												],
												[
													30.857,
													-238.449
												],
												[
													42.838,
													-203.209
												],
												[
													100.63,
													-112.996
												],
												[
													132.347,
													-253.25
												],
												[
													184.503,
													-85.509
												],
												[
													175.339,
													-85.509
												],
												[
													205.645,
													12.458
												],
												[
													231.723,
													42.764
												],
												[
													283.172,
													87.871
												],
												[
													283.172,
													153.417
												],
												[
													171.11,
													154.122
												],
												[
													83.011,
													140.026
												],
												[
													1.255,
													185.837
												],
												[
													-54.423,
													154.122
												],
												[
													-90.369,
													173.856
												],
												[
													-51.95,
													219.276
												],
												[
													-111.634,
													253.25
												],
												[
													-283.172,
													150.563
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.13300000359,
											0.13300000359,
											0.156999999402,
											1
										],
										"ix": 4
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 5
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											283.422,
											253.5
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 239.00000973467,
					"st": -6.00000024438501,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_33",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "first outline 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								918,
								658,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								133,
								119,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-21.697,
													-11.248
												],
												[
													21.697,
													11.248
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											241.201,
											91.484
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-21.377,
													-2.054
												],
												[
													21.377,
													2.054
												],
												[
													21.137,
													0.922
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											141.27,
											104.473
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.822,
													-1.085
												],
												[
													-0.859,
													1.085
												],
												[
													0.859,
													-0.845
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											119.034,
											103.264
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-1.207,
													-3.003
												],
												[
													-1.273,
													0.892
												],
												[
													1.273,
													3.003
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											121.1,
											5.503
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.001,
													-0.001
												],
												[
													-0.001,
													0.001
												],
												[
													0.001,
													0.001
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											119.105,
											5.797
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-14.534,
													-1.347
												],
												[
													-58.302,
													63.192
												],
												[
													58.302,
													-63.192
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											60.802,
											68.989
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-29.842,
													39.697
												],
												[
													29.842,
													5.723
												],
												[
													-8.577,
													-39.697
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											203.882,
											195.171
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 7,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													17.988,
													48.192
												],
												[
													19.603,
													-47.593
												],
												[
													18.882,
													-48.192
												],
												[
													18.882,
													-48.191
												],
												[
													-19.603,
													42.856
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											100.224,
											53.988
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"np": 2,
							"cix": 2,
							"ix": 8,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													19.763,
													-26.212
												],
												[
													27.367,
													8.2
												],
												[
													39.677,
													63.919
												],
												[
													70.262,
													30.306
												],
												[
													19.763,
													-27.736
												],
												[
													-0.464,
													-6.062
												],
												[
													-70.262,
													-63.919
												],
												[
													-30.229,
													32.969
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											192.636,
											72.426
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 2,
							"cix": 2,
							"ix": 9,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													77.899,
													-10.383
												],
												[
													114.906,
													-29.511
												],
												[
													48.218,
													-59.043
												],
												[
													45.24,
													-59.329
												],
												[
													52.049,
													-27.172
												],
												[
													-0.853,
													34.599
												],
												[
													0.768,
													-61.508
												],
												[
													-55.421,
													1.599
												],
												[
													-36.785,
													-69.012
												],
												[
													-114.906,
													-33.676
												],
												[
													56.633,
													69.012
												],
												[
													58.988,
													-33.242
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											117.407,
											165.856
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 10",
							"np": 2,
							"cix": 2,
							"ix": 10,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 61.0000024845809,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "second outline 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1188,
								586,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								171.5,
								119.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-25.509,
													-54.307
												],
												[
													-11.582,
													8.007
												],
												[
													25.509,
													54.307
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											314.588,
											149.234
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-42.939,
													-58.321
												],
												[
													42.939,
													-53.116
												],
												[
													-16.375,
													58.321
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											244.409,
											145.926
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.823,
													-21.851
												],
												[
													-30.694,
													21.851
												],
												[
													30.694,
													0.082
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											233.275,
											64.13
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													6.953,
													-100.873
												],
												[
													33.139,
													-15.768
												],
												[
													59.703,
													100.873
												],
												[
													-27.61,
													85.466
												],
												[
													34.25,
													-17.393
												],
												[
													-59.703,
													-9.816
												],
												[
													-29.712,
													82.719
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											168.331,
											103.373
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-25.224,
													71.202
												],
												[
													25.224,
													-71.202
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											83.403,
											164.759
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-168.798,
													85.015
												],
												[
													-113.119,
													116.731
												],
												[
													-30.577,
													69.608
												],
												[
													56.735,
													85.015
												],
												[
													168.798,
													84.31
												],
												[
													168.798,
													18.764
												],
												[
													117.78,
													-24.304
												],
												[
													92.672,
													-55.02
												],
												[
													3.985,
													-116.731
												],
												[
													-62.671,
													-25.674
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											171.298,
											119.231
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 61.0000024845809,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "third outline 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1005,
								516,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								103,
								126.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-4.868,
													8.651
												],
												[
													4.904,
													-8.651
												],
												[
													-4.904,
													8.543
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											130.454,
											45.939
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													33.084,
													12.678
												],
												[
													15.005,
													0.646
												],
												[
													21.289,
													24.29
												],
												[
													-33.084,
													-29.021
												],
												[
													17.415,
													29.021
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											128.876,
											220.981
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													15.858,
													-1.888
												],
												[
													-15.858,
													-17.394
												],
												[
													4.858,
													17.394
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											130.501,
											19.894
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-48.138,
													23.798
												],
												[
													-31.208,
													-26.75
												],
												[
													-27.34,
													-2.583
												],
												[
													11.494,
													-51.843
												],
												[
													39.272,
													-41.692
												],
												[
													39.272,
													-50.541
												],
												[
													39.272,
													-51.843
												],
												[
													13.279,
													-68.507
												],
												[
													11.494,
													-51.843
												],
												[
													-8.655,
													-71.856
												],
												[
													-31.208,
													-26.75
												],
												[
													-72.872,
													3.295
												],
												[
													0.194,
													63.863
												],
												[
													20.421,
													42.189
												],
												[
													38.842,
													-39.781
												],
												[
													68.509,
													71.856
												],
												[
													72.872,
													-27.719
												],
												[
													39.272,
													-41.692
												],
												[
													-19.503,
													46.383
												],
												[
													-27.34,
													-2.583
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											75.372,
											149.77
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-22.162,
													-110.844
												],
												[
													-21.325,
													-16.447
												],
												[
													-5.468,
													-6.296
												],
												[
													8.065,
													-3.734
												],
												[
													12.275,
													7.677
												],
												[
													33.099,
													111.873
												],
												[
													67.138,
													76.371
												],
												[
													11.72,
													5.351
												],
												[
													-10.383,
													-59.783
												],
												[
													-10.968,
													-58.746
												],
												[
													-21.325,
													-111.873
												],
												[
													-67.138,
													-55.49
												],
												[
													-47.318,
													-33.111
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											135.969,
											114.374
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.921,
													-8.283
												],
												[
													-1.057,
													9.515
												],
												[
													1.057,
													-9.515
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											67.774,
											68.399
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												]
											],
											"v": [
												[
													114.644,
													108.077
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 7,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 61.0000024845809,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "fourth outline 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1102,
								434,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								75,
								153,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												]
											],
											"v": [
												[
													118.426,
													160.217
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.39,
													0.088
												],
												[
													0.39,
													0.14
												],
												[
													0.173,
													-0.14
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											38.52,
											249.622
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.485,
													0.82
												],
												[
													0.485,
													0.43
												],
												[
													-0.485,
													-0.82
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											36.31,
											246.604
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													6.641,
													-14.031
												],
												[
													-22.43,
													-40.833
												],
												[
													11.248,
													40.833
												],
												[
													22.43,
													30.65
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											105.869,
											118.7
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												]
											],
											"v": [
												[
													135.248,
													169.01
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													8.059,
													10.715
												],
												[
													6.718,
													-0.104
												],
												[
													8.411,
													-1.922
												],
												[
													-8.411,
													-10.715
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											126.837,
											170.931
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-16.114,
													-22.341
												],
												[
													16.114,
													7.374
												],
												[
													-0.325,
													22.341
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											128.624,
											127.01
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 7,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													17.497,
													65.635
												],
												[
													28.671,
													53.643
												],
												[
													27.188,
													40.025
												],
												[
													28.896,
													24.579
												],
												[
													21.495,
													13.026
												],
												[
													-28.896,
													-65.635
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											117.751,
											103.375
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"np": 2,
							"cix": 2,
							"ix": 8,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													13.744,
													-2.444
												],
												[
													1.761,
													-37.684
												],
												[
													-13.744,
													29.272
												],
												[
													8.326,
													37.684
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											75.112,
											40.184
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 2,
							"cix": 2,
							"ix": 9,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													34.117,
													-26.167
												],
												[
													6.8,
													-8.981
												],
												[
													6.591,
													-8.896
												],
												[
													15.261,
													17.807
												],
												[
													-47.993,
													13.605
												],
												[
													-6.847,
													66.65
												],
												[
													47.993,
													-54.51
												],
												[
													27.184,
													-66.65
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											86.903,
											236.156
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 10",
							"np": 2,
							"cix": 2,
							"ix": 10,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													27.793,
													-48.544
												],
												[
													-31.076,
													48.544
												],
												[
													31.076,
													-3.438
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											33.575,
											118
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 2,
							"cix": 2,
							"ix": 11,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-1.742,
													-58.199
												],
												[
													-28.834,
													11.178
												],
												[
													25.388,
													34.332
												],
												[
													-27.865,
													55.752
												],
												[
													-25.967,
													58.199
												],
												[
													28.834,
													35.978
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											64.659,
											191.282
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 12",
							"np": 2,
							"cix": 2,
							"ix": 12,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-45.053,
													22.373
												],
												[
													2.454,
													-47.091
												],
												[
													4.193,
													-45.852
												],
												[
													53.625,
													-10.667
												],
												[
													57.963,
													-19.956
												],
												[
													56.654,
													-20.64
												],
												[
													4.188,
													-65.611
												],
												[
													0.905,
													-46
												],
												[
													-54.59,
													-6.948
												],
												[
													-57.963,
													-13.63
												],
												[
													-37.222,
													49.388
												],
												[
													-24.638,
													65.611
												],
												[
													-24.638,
													22.286
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											60.463,
											180.173
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 13",
							"np": 2,
							"cix": 2,
							"ix": 13,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 61.0000024845809,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 4,
					"nm": "fifth outline 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1196,
								420,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								87.5,
								160.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.782,
													38.051
												],
												[
													-0.782,
													-38.051
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											142.405,
											210.891
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.015,
													-0.368
												],
												[
													-0.339,
													0.1
												],
												[
													0.339,
													0.368
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											84.857,
											209.77
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.652,
													0.724
												],
												[
													0.652,
													-0.134
												],
												[
													-0.194,
													-0.724
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											85.848,
											209.414
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													33.242,
													67.446
												],
												[
													3.699,
													-28.936
												],
												[
													-2.141,
													-29.522
												],
												[
													-31.898,
													-54.126
												],
												[
													-33.242,
													-53.245
												],
												[
													-29.016,
													-66.61
												],
												[
													-29.053,
													-67.099
												],
												[
													-28.401,
													-67.446
												],
												[
													0.993,
													-39.66
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											137.923,
											201.776
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													12.558,
													-52.321
												],
												[
													23.732,
													-64.313
												],
												[
													23.958,
													-65.19
												],
												[
													25.023,
													-65.89
												],
												[
													22.048,
													-79.782
												],
												[
													23.732,
													-64.313
												],
												[
													10.865,
													-50.504
												],
												[
													12.205,
													-39.684
												],
												[
													-41.009,
													79.782
												],
												[
													41.009,
													-28.274
												],
												[
													12.205,
													-39.684
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											43.508,
											238.144
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													9.581,
													26.254
												],
												[
													21.953,
													37.95
												],
												[
													13.046,
													37.055
												],
												[
													12.287,
													36.979
												],
												[
													12.316,
													37.095
												],
												[
													-42.836,
													73.418
												],
												[
													42.836,
													133.361
												],
												[
													22.502,
													38.159
												],
												[
													-30.699,
													-133.361
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											129.335,
											135.861
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													21.657,
													54.246
												],
												[
													11.423,
													-77.931
												],
												[
													-21.657,
													77.931
												],
												[
													20.086,
													55.082
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											87.214,
											80.431
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 7,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.952,
													29.722
												],
												[
													18.074,
													-30.436
												],
												[
													-18.074,
													-6.713
												],
												[
													-1.735,
													30.436
												],
												[
													-1.11,
													29.612
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											86.606,
											178.967
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"np": 2,
							"cix": 2,
							"ix": 8,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 61.0000024845809,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_34",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "fifth outline",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1196,
								420,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								87.5,
								160.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.782,
													38.051
												],
												[
													-0.782,
													-38.051
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											142.405,
											210.891
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.015,
													-0.368
												],
												[
													-0.339,
													0.1
												],
												[
													0.339,
													0.368
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											84.857,
											209.77
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.652,
													0.724
												],
												[
													0.652,
													-0.134
												],
												[
													-0.194,
													-0.724
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											85.848,
											209.414
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													33.242,
													67.446
												],
												[
													3.699,
													-28.936
												],
												[
													-2.141,
													-29.522
												],
												[
													-31.898,
													-54.126
												],
												[
													-33.242,
													-53.245
												],
												[
													-29.016,
													-66.61
												],
												[
													-29.053,
													-67.099
												],
												[
													-28.401,
													-67.446
												],
												[
													0.993,
													-39.66
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											137.923,
											201.776
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													12.558,
													-52.321
												],
												[
													23.732,
													-64.313
												],
												[
													23.958,
													-65.19
												],
												[
													25.023,
													-65.89
												],
												[
													22.048,
													-79.782
												],
												[
													23.732,
													-64.313
												],
												[
													10.865,
													-50.504
												],
												[
													12.205,
													-39.684
												],
												[
													-41.009,
													79.782
												],
												[
													41.009,
													-28.274
												],
												[
													12.205,
													-39.684
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											43.508,
											238.144
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													9.581,
													26.254
												],
												[
													21.953,
													37.95
												],
												[
													13.046,
													37.055
												],
												[
													12.287,
													36.979
												],
												[
													12.316,
													37.095
												],
												[
													-42.836,
													73.418
												],
												[
													42.836,
													133.361
												],
												[
													22.502,
													38.159
												],
												[
													-30.699,
													-133.361
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											129.335,
											135.861
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													21.657,
													54.246
												],
												[
													11.423,
													-77.931
												],
												[
													-21.657,
													77.931
												],
												[
													20.086,
													55.082
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											87.214,
											80.431
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 7,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.952,
													29.722
												],
												[
													18.074,
													-30.436
												],
												[
													-18.074,
													-6.713
												],
												[
													-1.735,
													30.436
												],
												[
													-1.11,
													29.612
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											86.606,
											178.967
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"np": 2,
							"cix": 2,
							"ix": 8,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.268
											],
											"y": [
												1.001
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"n": [
											"0p268_1p001_0p333_0"
										],
										"t": 61,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 79.000003217736
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 35,
								"ix": 3
							},
							"m": 1,
							"ix": 9,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 0,
					"op": 83.0000033806593,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "fourth outline",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1102,
								434,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								75,
								153,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												]
											],
											"v": [
												[
													118.426,
													160.217
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.39,
													0.088
												],
												[
													0.39,
													0.14
												],
												[
													0.173,
													-0.14
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											38.52,
											249.622
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.485,
													0.82
												],
												[
													0.485,
													0.43
												],
												[
													-0.485,
													-0.82
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											36.31,
											246.604
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													6.641,
													-14.031
												],
												[
													-22.43,
													-40.833
												],
												[
													11.248,
													40.833
												],
												[
													22.43,
													30.65
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											105.869,
											118.7
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												]
											],
											"v": [
												[
													135.248,
													169.01
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													8.059,
													10.715
												],
												[
													6.718,
													-0.104
												],
												[
													8.411,
													-1.922
												],
												[
													-8.411,
													-10.715
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											126.837,
											170.931
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-16.114,
													-22.341
												],
												[
													16.114,
													7.374
												],
												[
													-0.325,
													22.341
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											128.624,
											127.01
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 7,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													17.497,
													65.635
												],
												[
													28.671,
													53.643
												],
												[
													27.188,
													40.025
												],
												[
													28.896,
													24.579
												],
												[
													21.495,
													13.026
												],
												[
													-28.896,
													-65.635
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											117.751,
											103.375
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"np": 2,
							"cix": 2,
							"ix": 8,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													13.744,
													-2.444
												],
												[
													1.761,
													-37.684
												],
												[
													-13.744,
													29.272
												],
												[
													8.326,
													37.684
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											75.112,
											40.184
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 2,
							"cix": 2,
							"ix": 9,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													34.117,
													-26.167
												],
												[
													6.8,
													-8.981
												],
												[
													6.591,
													-8.896
												],
												[
													15.261,
													17.807
												],
												[
													-47.993,
													13.605
												],
												[
													-6.847,
													66.65
												],
												[
													47.993,
													-54.51
												],
												[
													27.184,
													-66.65
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											86.903,
											236.156
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 10",
							"np": 2,
							"cix": 2,
							"ix": 10,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													27.793,
													-48.544
												],
												[
													-31.076,
													48.544
												],
												[
													31.076,
													-3.438
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											33.575,
											118
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 2,
							"cix": 2,
							"ix": 11,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-1.742,
													-58.199
												],
												[
													-28.834,
													11.178
												],
												[
													25.388,
													34.332
												],
												[
													-27.865,
													55.752
												],
												[
													-25.967,
													58.199
												],
												[
													28.834,
													35.978
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											64.659,
											191.282
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 12",
							"np": 2,
							"cix": 2,
							"ix": 12,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-45.053,
													22.373
												],
												[
													2.454,
													-47.091
												],
												[
													4.193,
													-45.852
												],
												[
													53.625,
													-10.667
												],
												[
													57.963,
													-19.956
												],
												[
													56.654,
													-20.64
												],
												[
													4.188,
													-65.611
												],
												[
													0.905,
													-46
												],
												[
													-54.59,
													-6.948
												],
												[
													-57.963,
													-13.63
												],
												[
													-37.222,
													49.388
												],
												[
													-24.638,
													65.611
												],
												[
													-24.638,
													22.286
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											60.463,
											180.173
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 13",
							"np": 2,
							"cix": 2,
							"ix": 13,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.322
											],
											"y": [
												0.995
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"n": [
											"0p322_0p995_0p333_0"
										],
										"t": 40,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 70.0000028511585
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 45,
								"ix": 3
							},
							"m": 1,
							"ix": 14,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 0,
					"op": 83.0000033806593,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "third outline",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1005,
								516,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								103,
								126.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-4.868,
													8.651
												],
												[
													4.904,
													-8.651
												],
												[
													-4.904,
													8.543
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											130.454,
											45.939
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													33.084,
													12.678
												],
												[
													15.005,
													0.646
												],
												[
													21.289,
													24.29
												],
												[
													-33.084,
													-29.021
												],
												[
													17.415,
													29.021
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											128.876,
											220.981
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													15.858,
													-1.888
												],
												[
													-15.858,
													-17.394
												],
												[
													4.858,
													17.394
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											130.501,
											19.894
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-48.138,
													23.798
												],
												[
													-31.208,
													-26.75
												],
												[
													-27.34,
													-2.583
												],
												[
													11.494,
													-51.843
												],
												[
													39.272,
													-41.692
												],
												[
													39.272,
													-50.541
												],
												[
													39.272,
													-51.843
												],
												[
													13.279,
													-68.507
												],
												[
													11.494,
													-51.843
												],
												[
													-8.655,
													-71.856
												],
												[
													-31.208,
													-26.75
												],
												[
													-72.872,
													3.295
												],
												[
													0.194,
													63.863
												],
												[
													20.421,
													42.189
												],
												[
													38.842,
													-39.781
												],
												[
													68.509,
													71.856
												],
												[
													72.872,
													-27.719
												],
												[
													39.272,
													-41.692
												],
												[
													-19.503,
													46.383
												],
												[
													-27.34,
													-2.583
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											75.372,
											149.77
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-22.162,
													-110.844
												],
												[
													-21.325,
													-16.447
												],
												[
													-5.468,
													-6.296
												],
												[
													8.065,
													-3.734
												],
												[
													12.275,
													7.677
												],
												[
													33.099,
													111.873
												],
												[
													67.138,
													76.371
												],
												[
													11.72,
													5.351
												],
												[
													-10.383,
													-59.783
												],
												[
													-10.968,
													-58.746
												],
												[
													-21.325,
													-111.873
												],
												[
													-67.138,
													-55.49
												],
												[
													-47.318,
													-33.111
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											135.969,
											114.374
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.921,
													-8.283
												],
												[
													-1.057,
													9.515
												],
												[
													1.057,
													-9.515
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											67.774,
											68.399
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												]
											],
											"v": [
												[
													114.644,
													108.077
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 7,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.502
											],
											"y": [
												1.001
											]
										},
										"o": {
											"x": [
												0.751
											],
											"y": [
												-0.003
											]
										},
										"n": [
											"0p502_1p001_0p751_-0p003"
										],
										"t": 25,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 48.0000019550801
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 60,
								"ix": 3
							},
							"m": 1,
							"ix": 8,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 0,
					"op": 83.0000033806593,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "second outline",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1188,
								586,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								171.5,
								119.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-25.509,
													-54.307
												],
												[
													-11.582,
													8.007
												],
												[
													25.509,
													54.307
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											314.588,
											149.234
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-42.939,
													-58.321
												],
												[
													42.939,
													-53.116
												],
												[
													-16.375,
													58.321
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											244.409,
											145.926
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.823,
													-21.851
												],
												[
													-30.694,
													21.851
												],
												[
													30.694,
													0.082
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											233.275,
											64.13
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													6.953,
													-100.873
												],
												[
													33.139,
													-15.768
												],
												[
													59.703,
													100.873
												],
												[
													-27.61,
													85.466
												],
												[
													34.25,
													-17.393
												],
												[
													-59.703,
													-9.816
												],
												[
													-29.712,
													82.719
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											168.331,
											103.373
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-25.224,
													71.202
												],
												[
													25.224,
													-71.202
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											83.403,
											164.759
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-168.798,
													85.015
												],
												[
													-113.119,
													116.731
												],
												[
													-30.577,
													69.608
												],
												[
													56.735,
													85.015
												],
												[
													168.798,
													84.31
												],
												[
													168.798,
													18.764
												],
												[
													117.78,
													-24.304
												],
												[
													92.672,
													-55.02
												],
												[
													3.985,
													-116.731
												],
												[
													-62.671,
													-25.674
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											171.298,
											119.231
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 11,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 36.0000014663101
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 45,
								"ix": 3
							},
							"m": 1,
							"ix": 7,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 0,
					"op": 83.0000033806593,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 4,
					"nm": "first outline",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								918,
								658,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								133,
								119,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-21.697,
													-11.248
												],
												[
													21.697,
													11.248
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											241.201,
											91.484
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-21.377,
													-2.054
												],
												[
													21.377,
													2.054
												],
												[
													21.137,
													0.922
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											141.27,
											104.473
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.822,
													-1.085
												],
												[
													-0.859,
													1.085
												],
												[
													0.859,
													-0.845
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											119.034,
											103.264
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 2,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-1.207,
													-3.003
												],
												[
													-1.273,
													0.892
												],
												[
													1.273,
													3.003
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											121.1,
											5.503
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.001,
													-0.001
												],
												[
													-0.001,
													0.001
												],
												[
													0.001,
													0.001
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											119.105,
											5.797
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-14.534,
													-1.347
												],
												[
													-58.302,
													63.192
												],
												[
													58.302,
													-63.192
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											60.802,
											68.989
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 6",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-29.842,
													39.697
												],
												[
													29.842,
													5.723
												],
												[
													-8.577,
													-39.697
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											203.882,
											195.171
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 7",
							"np": 2,
							"cix": 2,
							"ix": 7,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													17.988,
													48.192
												],
												[
													19.603,
													-47.593
												],
												[
													18.882,
													-48.192
												],
												[
													18.882,
													-48.191
												],
												[
													-19.603,
													42.856
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											100.224,
											53.988
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"np": 2,
							"cix": 2,
							"ix": 8,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													19.763,
													-26.212
												],
												[
													27.367,
													8.2
												],
												[
													39.677,
													63.919
												],
												[
													70.262,
													30.306
												],
												[
													19.763,
													-27.736
												],
												[
													-0.464,
													-6.062
												],
												[
													-70.262,
													-63.919
												],
												[
													-30.229,
													32.969
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											192.636,
											72.426
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 2,
							"cix": 2,
							"ix": 9,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													77.899,
													-10.383
												],
												[
													114.906,
													-29.511
												],
												[
													48.218,
													-59.043
												],
												[
													45.24,
													-59.329
												],
												[
													52.049,
													-27.172
												],
												[
													-0.853,
													34.599
												],
												[
													0.768,
													-61.508
												],
												[
													-55.421,
													1.599
												],
												[
													-36.785,
													-69.012
												],
												[
													-114.906,
													-33.676
												],
												[
													56.633,
													69.012
												],
												[
													58.988,
													-33.242
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											117.407,
											165.856
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 10",
							"np": 2,
							"cix": 2,
							"ix": 10,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.503
											],
											"y": [
												1.004
											]
										},
										"o": {
											"x": [
												0.708
											],
											"y": [
												0.002
											]
										},
										"n": [
											"0p503_1p004_0p708_0p002"
										],
										"t": 1,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 21.0000008553475
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 60,
								"ix": 3
							},
							"m": 1,
							"ix": 11,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						}
					],
					"ip": 0,
					"op": 83.0000033806593,
					"st": 0,
					"bm": 0
				}
			]
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 0,
			"nm": "final edit",
			"refId": "comp_28",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						499,
						288,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						475,
						325,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"w": 950,
			"h": 650,
			"ip": 0,
			"op": 236.000009612477,
			"st": 0,
			"bm": 0
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/app-modernization/animations/hero.json
// module id = 1359
// module chunks = 0